import { InMemoryCache } from '@aws-amplify/cache'
import LOG from '../../../logging/Logger'
import moment from 'moment'

const subCacheKey = 'userSubscriptionDeets'
const cacheMinutes = 30

function getCacheSubscription() {
  const subscriptionDetails = InMemoryCache.getItem(subCacheKey)
  LOG.debug('retrieved user sub deets from cache: ', subscriptionDetails)
  return subscriptionDetails
}

function putCacheSubscription(subscriptionDetails) {
  LOG.debug('add user sub deets to cache:', subscriptionDetails)

  const expiry =
    subscriptionDetails.subEndDate &&
    moment(subscriptionDetails.subEndDate) > moment()
      ? subscriptionDetails.subEndDate
      : moment().add(cacheMinutes, 'minutes')

  InMemoryCache.setItem(subCacheKey, subscriptionDetails, {
    expires: expiry
  })
}

function invalidateCacheSubscription() {
  LOG.debug('invalidating cache')
  InMemoryCache.removeItem(subCacheKey)
}

export {
  getCacheSubscription,
  putCacheSubscription,
  invalidateCacheSubscription
}
